import { Crop } from 'react-image-crop';
import {
	SET_NEW_STANDARD_CROP,
	SET_NEW_STANDARD_CROPPED_IMAGE_PREVIEW,
	SET_OLD_STANDARD_CROP,
	SET_OLD_STANDARD_CROPPED_IMAGE_PREVIEW,
	SET_PORTRAIT_CROP,
	SET_PORTRAIT_CROPPED_IMAGE_PREVIEW,
	SET_SELECTED_CROP_AR_TYPE,
	SET_SELECTED_IMG_REF,
	SET_STANDARD_CROP,
	SET_STANDARD_CROPPED_IMAGE_PREVIEW,
	SET_WIDE_CROP,
	SET_WIDE_CROPPED_IMAGE_PREVIEW
} from '../types/crop-types';
import { AspectRatiosEnum } from '../../components/SubSections/Topic/imageComponents/editImage';
import React from 'react';

export const setSelectedCropARType = (response: AspectRatiosEnum) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_SELECTED_CROP_AR_TYPE,
			payload: response
		});
	};
};

export const setStandardCrop = (response: Crop | null) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_STANDARD_CROP,
			payload: response
		});
	};
};

export const setNewStandardCrop = (response: Crop | null) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_NEW_STANDARD_CROP,
			payload: response
		});
	};
};

export const setOldStandardCrop = (response: Crop | null) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_OLD_STANDARD_CROP,
			payload: response
		});
	};
};

export const setPortraitCrop = (response: Crop | null) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_PORTRAIT_CROP,
			payload: response
		});
	};
};

export const setWideCrop = (response: Crop | null) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_WIDE_CROP,
			payload: response
		});
	};
};

export const setStandardCroppedImagePreveiw = (response: Crop) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_STANDARD_CROPPED_IMAGE_PREVIEW,
			payload: response
		});
	};
};

export const setNewStandardCroppedImagePreveiw = (
	response: HTMLImageElement
) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_NEW_STANDARD_CROPPED_IMAGE_PREVIEW,
			payload: response
		});
	};
};

export const setOldStandardCroppedImagePreveiw = (
	response: HTMLImageElement
) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_OLD_STANDARD_CROPPED_IMAGE_PREVIEW,
			payload: response
		});
	};
};

export const setPortraitCroppedImagePreveiw = (response: HTMLImageElement) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_PORTRAIT_CROPPED_IMAGE_PREVIEW,
			payload: response
		});
	};
};

export const setWideCroppedImagePreveiw = (response: HTMLImageElement) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_WIDE_CROPPED_IMAGE_PREVIEW,
			payload: response
		});
	};
};

export const setSeletedImgRef = (
	response: React.RefObject<HTMLImageElement>
) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_SELECTED_IMG_REF,
			payload: response
		});
	};
};
